import { render, staticRenderFns } from "./ProductionDoctorMonthChart.vue?vue&type=template&id=3eae99d4&scoped=true&"
import script from "./ProductionDoctorMonthChart.vue?vue&type=script&lang=js&"
export * from "./ProductionDoctorMonthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eae99d4",
  null
  
)

export default component.exports